import {
  BUTTON,
  CHARTS,
  CONTAINER,
  ICON,
  IMAGE,
  MINI_PLAYER,
  SCROLL_CONTAINER,
  TEXT,
  NUMBER_PICKER,
  FORM,
  SLIDER,
} from '../constants.js';
import text from '../components/text/text.jsx';
import Button from '../components/button/button.jsx';
import image from '../components/image/image.jsx';
import { Gauge as GaugeChart } from '../components/charts';
import container from '../components/container/container.jsx';
import { Icon } from '../components/icon/icon.jsx';
import Slide from '../components/slide/slide.jsx';
import { Div } from '../components/div.jsx';
import { ScrollContainer } from '../components/scroll-container/scroll-container.jsx';
import { NumberPicker } from '../components/number-picker/number-picker.tsx';
import Form from '../components/form/form.tsx';
import Slider from '../components/slider/slider.tsx';

const widgetImplementations = new Map([
  [TEXT, text],
  [BUTTON, Button],
  [IMAGE, image],
  [CHARTS.GAUGE, GaugeChart],
  [MINI_PLAYER, Div],
  [CONTAINER, container],
  [ICON, Icon],
  [SCROLL_CONTAINER, ScrollContainer],
  [NUMBER_PICKER, NumberPicker],
  [SLIDER, Slider],
  [FORM, Form],
  ['div', Div],
]);
const Noop = (type) => {
  // eslint-disable-next-line react/display-name
  return () => {
    console.warn(`Attempt to render unknown widget ${type}, render nothing`);
    return null;
  };
};

export function mapWidgetImpl(schema) {
  for (const widgetKey in schema.widgets) {
    const widget = schema.widgets[widgetKey];
    widget._type ??= widget.type;

    if (widgetImplementations.has(widget.type)) {
      widget.type = widgetImplementations.get(widget.type);
    } else {
      widget.type = Noop(widget.type);
    }
  }

  schema.slides.forEach((slide) => {
    slide.type = Slide;
  });

  return schema;
}
